function setupModelViewer(node) {
  const modelEls = node.querySelectorAll("model-viewer")

  if (modelEls.length !== 0) {
    initModels()
  }

  function initModels() {
    window.Shopify.loadFeatures([
      {
        name: "model-viewer-ui",
        version: "1.0",
        onLoad: initModelViewers,
      },
    ])

    window.Shopify.loadFeatures([
      {
        name: "shopify-xr",
        version: "1.0",
        onLoad: initShopifyXr,
      },
    ])
  }

  function initModelViewers(errors) {
    if (errors) return

    modelEls.forEach((model) => {
      initCustomModelButtons(model)
    })
  }

  function initShopifyXr() {
    if (!window.ShopifyXR) {
      document.addEventListener("shopify_xr_initialized", () => {
        initShopifyXr()
      })
    } else {
      document.querySelectorAll("[id^='ModelJSON-']").forEach((modelJSON) => {
        window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent))
        modelJSON.remove()
      })

      window.ShopifyXR.setupXRElements()
    }
  }

  function initCustomModelButtons(model) {
    const viewer = new window.Shopify.ModelViewerUI(model)

    const parentContainer = model.closest(".product-media__item")
    const poster = parentContainer.querySelector(".model-viewer__poster")
    const closeBtn = parentContainer.querySelector(
      ".model-viewer__close-button",
    )

    poster.addEventListener("click", () => {
      parentContainer.classList.add("model-viewer__active")
      viewer.play()
    })

    poster.addEventListener("keydown", (event) => {
      if (event.key === "Enter") {
        parentContainer.classList.add("model-viewer__active")
        viewer.play()
      }
    })

    closeBtn.addEventListener("click", () => {
      parentContainer.classList.remove("model-viewer__active")
      viewer.pause()
    })

    closeBtn.addEventListener("keydown", (event) => {
      if (event.key === "Enter") {
        parentContainer.classList.remove("model-viewer__active")
        viewer.pause()
      }
    })
  }
}

export default setupModelViewer
